module.exports = __webpack_public_path__ + "static/media/banner1b.ab0f1b71.svg";